import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CommonModal, CustomPagination } from 'components'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { deleteZoneData, getZoneListData } from '_services/accountsServices/zoneServices';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { constant } from 'constants/constant';
import { deleteVehicleGroupData, getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import AddEditVehicleDocTypeModel from 'modals/AddEditVehicleDocTypeModel/AddEditVehicleDocTypeModel';
import { deleteVehicleDocData, getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import { CiLock, CiUnlock } from 'react-icons/ci';
import { deleteItems, deleteStore, getItemsList, getStoreList } from '_services/workShopServices/workShopServices';
import AddEditStoreModel from 'modals/AddEditStoreModel';
import { WorkshopAddItem } from 'modals';
import '../../WorkShop/workshop.css'

const Items = () => {

  useDocumentTitle("Items | T360");

  const { settingChild } = useContext(UserContext);
  const settingChildVehicleGrp = settingChild?.find((i) => i?.label === "Vehicle Group");
  const [showAddItem, setShowAddItem] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [itemsDataList, setItemsDataList] = useState([])
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const prevFilterRef = useRef();
  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: '',
    // status: 1
  });

  const toggleItemsModelData = () => {
    setShowAddItem(!showAddItem);
  };

  const getDataItemList = async () => {
    try {
      let object = {
        ...filter,
        company_id: StorageService.getCompanyId(),
      }
      const res = await getItemsList(object);
      if (res?.responseCode == 200) {
        setItemsDataList(res?.data?.itemData);
        setTotalItems(res?.data?.total_record);
      }
    } catch (error) {
      // throw error;
    }
  }

  useEffect(() => {
    const prevFilter = prevFilterRef.current;
    if (
      JSON.stringify(prevFilter) !== JSON.stringify(filter)
    ) {
      getDataItemList();
      prevFilterRef.current = filter;
    }
  }, [filter, showAddItem])

  const deleteHandler = (item) => {
    setIsDelete(item)
  }

  const submitDeleteItems = async (itemData) => {
    setLoading(true);
    try {
      let object = {}
      if (itemData?.disable) {
        object['id'] = itemData?._id;
        object['status'] = (itemData?.status === 1) ? 3 : 1;
      } else {
        object['id'] = isDelete?._id;
        object['status'] = 2;
      }
      const res = await deleteItems(object);
      if (res?.responseCode == 200) {
        toast.success(`${res?.responseMessage}`);
        getDataItemList();
        setLoading(false);
        setIsDelete(false);
      } else {
        if (res?.responseMessage) {
          toast.error(res?.responseMessage);
        }
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  }

  let propsObject = {
    isOpen: isDelete,
    closeModal: setIsDelete,
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitDeleteItems,
    isLoadding: loading,
  }

  let storeModelProps = {
    isOpen: showAddItem,
    closeModal: (e) => setShowAddItem(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: showAddItem?.isDetails ? "View Store" : (showAddItem?._id ? 'Update Store' : 'Add Store'),
    submitTitle: showAddItem?.isDetails ? "View Store" : (showAddItem?._id ? 'Update Store' : 'Add Store'),
    footerPart: showAddItem?.isDetails ? true : false,
    hideFooterSumbmitBtn: showAddItem?.isDetails ? true : false,
    hideCompletelyFoolter: showAddItem?.isDetails ? true : false,
    ApiCall: getDataItemList
  }

  const columns = [
    { header: "Item Name", accessor: "item_name" },
    { header: "Code", accessor: "code" },
    { header: "Category", accessor: "category" },
    { header: "Item Type", accessor: "item_type" },
    { header: "Part Type", accessor: "part_type" },
    { header: "Inventory", accessor: "manage_inventory" },
    { header: "Unit", accessor: "unit" },
    { header: "Status", accessor: "status" },
    { header: "Action", accessor: "action" }
  ];

  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      item_name: <span className='_tblText _style_ancer' onClick={(e) => setShowAddItem({ ...item, isDetails: true })}>
        <a className='_avPointer'>
          {item?.name ? item?.name : '-'} &nbsp;
        </a>
      </span>,
      code: <>{item?.code ? item?.code : '-'}</>,
      category: <>{item?.part_category_id?.name ? item?.part_category_id?.name : '-'}</>,
      item_type: <>{item?.type === 1 ? 'Parts' : 'Service'}</>,
      part_type: <>{item?.part_category_id?.part_type ? 'Multiple Type' : 'Single Type'}</>,
      manage_inventory: <>{item?.inventory ? 'Yes' : 'No'}</>,
      unit: <>{item?.type_unit ? item?.type_unit : '-'}</>,
      status: <div style={{ color: (item?.status === 1) ? "green" : "red" }}>{item?.status ? constant.ActionStore.find((el) => el?.value === item?.status)?.label : '-'}</div>,
      action: (
        <div
          className="_anvSwitcherNew form-check form-switch"
          style={{ width: "100px" }}
        >
          <div
            onClick={(e) => setShowAddItem(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='editIcon_avt'>
                <FiEdit color='blue' />
              </span>
            </span>
            {/* Edit */}
          </div>

          <div
            onClick={(e) => deleteHandler(item)}
            className='_avPointer'
          >
            <span className='_samAnchor'>
              <span className='deleteIcon_avt'>
                <FaRegTrashCan color='red' />
              </span>
            </span>
            {/* Delete */}
          </div>

          <div
            onClick={(e) => submitDeleteItems({ ...item, disable: true })}
            className='_avPointer'
          >
            {item?.status === 1 ? <CiUnlock color="green" size={20} /> : <CiLock color="red" size={20} />}
            {/* {item?.status === 1 ? 'Disable' : 'Enable'} */}
          </div>
        </div>
      ),
    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }))
  };

  return (
    <div className="__profilCmp_main">
      <ButtonHeading
        title={"Items (Parts)"}
        onClick={toggleItemsModelData}
        buttonTitle="Add Items"
        // buttonTitle={settingChildVehicleGrp?.create === 1 && "Add Vehicle Group"}
        showSearchFilter={{ search: true, filterOption: false, filterCount: true }}
        onClickFilterModal={(e) => setShowAddItem(!showAddItem)}
        filter={filter}
        setFilter={setFilter}
        isDebouncedSearch={true}
      />

      <div className='_tabWith_outTab'>
        <BootstrapTable
          columns={columns}
          data={rowListData(itemsDataList?.length > 0 ? itemsDataList : [])}
          // isLoading={loading}
        />

        {itemsDataList?.length ? <div className='paginationFt_avt'>
          <CustomPagination
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            currentPage={filter.offset}
            onPageChange={handlePageChange}
          />
        </div> : <></>}
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas mdOffcanvas ${showAddItem ? "show" : ""}`}
        tabIndex={-1}
        style={{ visibility: showAddItem ? "visible" : "hidden" }}
      >
        {showAddItem && (
          <WorkshopAddItem
            isOpen={showAddItem}
            onClose={(e) => setShowAddItem(false)}
            callListApi={(e) => getDataItemList(e)}
          />
        )}
      </div>
      <div className={showAddItem ? "offBack_drop" : ""}></div>

      {
        isDelete?._id && (
          <CommonModal {...propsObject}>
            <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
          </CommonModal>
        )
      }

    </div>
  )
}

export default Items